module.exports = __webpack_public_path__ + "img/bianjiezhifu.1275332d.png";